import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, renderSlot as _renderSlot, withCtx as _withCtx, createBlock as _createBlock, isRef as _isRef } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "flex" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "top-border-invisible" }),
  /*#__PURE__*/_createElementVNode("div", { class: "top-border" })
], -1)
const _hoisted_2 = { class: "pl-2 pr-2 h-full content" }

import TabView from 'primevue/tabview';
import TabPanel from 'primevue/tabpanel';
import { ref, onMounted, onUnmounted } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'DataTabs',
  props: ['headers', 'expandedActive', 'parentTabActive', 'tabIndex', 'inEditMode'],
  emits: ['tabChange'],
  setup(__props) {

_useCssVars(_ctx => ({
  "58d112b4": (__props.headers.length),
  "2cf4837a": (_unref(minWidth))
}))


const props = __props
let activeIndex = props.expandedActive !== undefined ? props.expandedActive : props.parentTabActive
let index = props.expandedActive == undefined ? 0 : props.parentTabActive
let minWidth = ref("85.3px")

onMounted(async () => {
    window.addEventListener("resize", setMinWidth);
    // setMinWidth()
})

onUnmounted(async () => {
    window.removeEventListener('resize', setMinWidth)
})

function setMinWidth() {
    var tabIndex = props.tabIndex ? props.tabIndex : index
    minWidth.value = document.getElementsByClassName("p-tabview-nav")[tabIndex].getBoundingClientRect().width.toString() + "px"
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(TabView), {
    activeIndex: _unref(activeIndex),
    "onUpdate:activeIndex": _cache[0] || (_cache[0] = ($event: any) => (_isRef(activeIndex) ? (activeIndex).value = $event : activeIndex = $event)),
    class: "z-0",
    onTabClick: _cache[1] || (_cache[1] = ($event: any) => {_ctx.$emit('tabChange', _unref(activeIndex)); setMinWidth();})
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.headers, (header, index) => {
        return (_openBlock(), _createBlock(_unref(TabPanel), {
          key: header,
          header: header,
          disabled: __props.inEditMode
        }, {
          default: _withCtx(() => [
            _hoisted_1,
            _createElementVNode("div", _hoisted_2, [
              _renderSlot(_ctx.$slots, "default", {
                index: index,
                header: header
              })
            ])
          ]),
          _: 2
        }, 1032, ["header", "disabled"]))
      }), 128))
    ]),
    _: 3
  }, 8, ["activeIndex"]))
}
}

})